import { render, staticRenderFns } from "./dialog-choose-company.vue?vue&type=template&id=45298500&scoped=true&"
import script from "./dialog-choose-company.vue?vue&type=script&lang=js&"
export * from "./dialog-choose-company.vue?vue&type=script&lang=js&"
import style0 from "./dialog-choose-company.vue?vue&type=style&index=0&id=45298500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45298500",
  null
  
)

export default component.exports